import { Injectable } from '@angular/core';
import {
  MatPaginatorIntl,
} from '@angular/material/paginator';
import { Subject } from 'rxjs';

@Injectable()
export class CustomPaginator implements MatPaginatorIntl {
  changes = new Subject<void>();

  // For internationalization, the `$localize` function from
  // the `@angular/localize` package can be used.
  firstPageLabel = `Primera p\xE1gina`;
  itemsPerPageLabel = `Registros por p\xE1gina:`;
  lastPageLabel = `Ultima p\xE1gina`;

  // You can set labels to an arbitrary string too, or dynamically compute
  // it through other third-party internationalization libraries.
  nextPageLabel = 'Siguiente';
  previousPageLabel = 'Anterior';

  getRangeLabel(page: number, pageSize: number, length: number): string {
    if (length === 0) {
      return `Pag. 1 de 1`;
    }
    const amountPages = Math.ceil(length / pageSize);
    return `Pag. ${page + 1} de ${amountPages}`;
  }
}
